import React from 'react';
import { NavLink } from 'react-router-dom';
import FacebookCommunityCard from './FacebookCommunityCard';

type Props = {};
declare const FivePrayerData: {
    Current_user: string;
    Site_title: string;
};

const Welcome = (props: Props) => {
    return (
        <div className="p-6 grid grid-cols-2 gap-6">
            {/* Left Side */}
            <div>
                <p className="text-3xl text-green-700 mb-3">
                    Hello {FivePrayerData?.Site_title}
                </p>
                <p className='text-base text-green-900'>Welcome to FivePrayer.</p>
            </div>

            {/* Right Side Content */}
            <div className="flex flex-col justify-center items-center text-center bg-white shadow-md rounded-lg p-6 relative">

                {/* 🔴 Major Update Notice with Ping on Left and Update Text */}

                <div className='flex flex-col items-center text-center py-3'>
                    <div className="relative flex items-center">
                        <div className="absolute  top-[-10px] left-[-15px]">
                            <span className="absolute inline-flex h-4 w-4 rounded-full bg-red-500 opacity-75 animate-ping"></span>
                            <span className="relative inline-flex h-4 w-4 rounded-full bg-red-500"></span>
                        </div>
                        <p className="text-red-600 font-bold text-3xl">
                            Major Update - Breaking Change
                        </p>
                    </div>
                    <p className="mt-4 text-base">
                        If this is your first time installing the FivePrayer plugin, you don't need to worry. However, if you are upgrading from version 1 to version 2, you <strong>must deactivate</strong> the plugin and <strong>activate it again</strong>.
                        Additionally, you will need to start from the beginning and set everything up as shown in
                        <NavLink to="/documentation" className="text-blue-500 hover:text-blue-700 font-semibold ml-1">
                            The FivePrayer Documentation
                        </NavLink>.
                        The documentation includes a YouTube video explaining the full setup process.
                    </p>


                </div>
                <FacebookCommunityCard />

                {/* Combined Text */}
                <div className="mt-16 text-base mb-4">
                    <p className="text-lg">
                        Hi <span className="text-lg pr-1 text-green-600 font-roboto font-bold">{FivePrayerData?.Current_user}</span>,
                        We're excited to share that we are continually improving the design and style of the FivePrayer plugin to make it more user-friendly for everyone.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Welcome;
